import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { Grid } from "@/comn/components";
import { Page, Group, Layout, Button } from "@/comn/components";
import { useForm, useFetch, usePopup, useStore, useToast, useAuth, useGrid, useModal, useResource } from "@/comn/hooks";
import {
    BASE,
    APIS,
    SCHEMA_FORM_CSTM_CD_SRCH,
    SCHEMA_GRID_ORGZ_SUB_CD,
    SF_ORGZ_SUB_SRCH,
} from "./services/ComnCdService";
import { Link } from "react-router-dom";

export const OrgzSubLst = (props: any) => {
    const pgeUid = "OrgzSubLst";
    const { t } = useTranslation();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();
    const modal = useModal();

    const form = {
        orgzSubSrch: useForm({
            defaultSchema: SF_ORGZ_SUB_SRCH,
            // defaultValues: { ...pgeStore?.form } || {},
        }),
    };

    const grid = {
        orgzSubLst: useGrid({
            defaultSchema: SCHEMA_GRID_ORGZ_SUB_CD,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getOrgzSubLst: useFetch({
            api: (page = grid.orgzSubLst.page) => {
                return APIS.getOrgzSubLst(form.orgzSubSrch.getValues(), page, grid.orgzSubLst.size);
            },
            enabled: comnUtils.isEmpty(form.orgzSubSrch.errors) && form.orgzSubSrch.isSubmitted,
            key: [grid.orgzSubLst.page, grid.orgzSubLst.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.orgzSubSrch.getValues(),
                    page: grid.orgzSubLst.page,
                    size: grid.orgzSubLst.size,
                });
            },
        }),
    };

    const handler = {
        click_Btn_Srch: () => {
            form.orgzSubSrch.handleSubmit(
                () => {
                    grid.orgzSubLst.setPage(0);
                    fetch.getOrgzSubLst.fetch(0);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },
    };

    const render = {
        grid_OrgzSubLst: {
            cell: {
                cstmOrgzCd: (arg: any) => {
                    const { binding, rowValues, value } = arg;
                    return (
                        <Link
                            to={"#"}
                            onClick={(e) => {
                                e.preventDefault();
                                props?.callback?.({ code: value, label: rowValues.cstmOrgzNm, rowData: rowValues });
                                modal.closeModal(props.id);
                            }}
                        >
                            {arg.value}
                        </Link>
                    );
                },
            },
        },
    };

    useEffect(() => {
        form.orgzSubSrch.setValue("cstmOrgzTpCd", props.params.cstmOrgzTpCd);
        handler.click_Btn_Srch();
    }, []);

    return (
        <Page title={t("T_ORGZ_SUB_LST")} info={true}>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.orgzSubSrch.schema.cstmOrgzCd}></Group.Control>
                                <Group.Control {...form.orgzSubSrch.schema.cstmOrgzNm}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.orgzSubSrch.reset();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.click_Btn_Srch();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    <Group.Section>
                        {/* * */}
                        <Grid
                            {...grid.orgzSubLst.grid}
                            data={fetch.getOrgzSubLst.data?.orgzSubList}
                            render={render.grid_OrgzSubLst}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
